import React, { createContext, useState, useEffect } from 'react';
import api from '../utils/api';
import Cookies from 'js-cookie'; // Añade esta importación

api.defaults.withCredentials = true;

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await api.get(`current-user/`);
        setUser(response.data);
      } catch (error) {
        console.error('Check auth error:', error.response?.data || error.message);
        setUser(null);
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const csrftoken = Cookies.get('csrftoken'); // Obtiene el token CSRF de la cookie
      const response = await api.post(`login/`, { email, password }, {
        headers: {
          'X-CSRFToken': csrftoken, // Añade el token al encabezado
        },
      });
      setUser(response.data.user);
      return true;
    } catch (error) {
      console.error('Login error:', error.response?.data || error.message);
      return false;
    }
  };

  const logout = async () => {
    try {
      const csrftoken = Cookies.get('csrftoken'); // Obtiene el token CSRF de la cookie
      await api.post(`logout/`, {}, {
        headers: {
          'X-CSRFToken': csrftoken, // Añade el token al encabezado
        },
      });
      setUser(null);
    } catch (error) {
      console.error('Logout error:', error.response?.data || error.message);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};